
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { AxiosData } from "@/common/http/http";
import { Util, getExcelJSONDataByList, getPageAPIs } from "@/common/util";
import { DeviceAPI } from "@/common/api/userOldManage/deviceList";
import { CommonApi } from "@/common/api/common";

// import { excuteDownloadExport2Excel } from "@/common/xlsx";
export const pageApiList = getPageAPIs(DeviceAPI);

import {
  // transferUserLevel2ch,
  defaultUserMemberList,
} from "@/common/config";


// 类型:1 2 3 4智能开关
// const deviceType2Ch: string[] = ['', '智能开关', '智能开关', '智能开关', '智能开关']

// 开关状态1:开0关
const deviceStatus2Tag: any[] = [
  {
    type: 'danger',
    label: '离线'
  },
  {
    type: '',
    label: '在线'
  }
]

@Component({
  filters: {
    // showDeviceTypeName(type: number) {
    //   return deviceType2Ch[type] || '未知'
    // }
  }
})
export default class OldDeviceList extends Vue {
  private utilInstance: any;
  private deviceApi: any;

  private commonApi: any;

  private deviceStatus2Tag: any[] = [
    ...deviceStatus2Tag
  ]

  constructor() {
    super();
    this.deviceApi = new DeviceAPI();

    this.commonApi = new CommonApi();

    this.utilInstance = new Util();

    // 封禁时间列表
    // this.all_forbidden_time_list = Util.getFoibiddenTimeList();
  }

  private get deviceGateId() {
    const route = this.$route 

    const {
      query = {}
    } = route || {}

    const {
      group_id = ''
    } = query
    console.log('111111111111',group_id)
    return group_id
  }

  private firstLoading: boolean = true;

  private form: any = {
    mobile: "", // 手机号
    userId: "", // 用户ID
  };

  private activated(): void {
    this.getTable();
  }
  private getTable(): void {
    this.deviceApi.getDeviceTableList(
      this.getDeviceTableListParams(),
      (res: any) => {
        console.log(res, "res");
        // this.tableData = res.data;
        const { data } = res;

        const { list, count, page, prepage } = data || {};

        const newTableList = Array.isArray(list)
          ? list.map(this.handleTableData)
          : [];

        this.$set(this.tablePage, "totalCount", count);
        this.$set(this.tablePage, "pageNo", page);
        this.$set(this.tablePage, "pageSize", prepage);

        this.tableData = newTableList;

        this.firstLoading = false;
      },
      () => {
        this.firstLoading = false;
      }
    );
  }

  private getDeviceTableListParams(mode = "all") {
    // mode 可选的值 all  noPageOption exportExcel
    const form = this.form;

    const tablePage = this.tablePage;

    const firstLoading = this.firstLoading;

    const {
      // userId, // 用户ID
      // userName, // 用户昵称
      // mobile, // 手机号
      // userLevel, // 会员等级
      // invite_code, // 邀请码
      // time, // 时间选择
    } = form || {};

    const { pageNo, pageSize } = tablePage || {};

    const outerParams: any = {
      group_id: this.deviceGateId
    };

    // if (userId) {
    //   outerParams.user_id = userId;
    // }

    // if (mobile) {
    //   outerParams.phone = mobile;
    // }

    // if (Array.isArray(time) && time.length === 2) {
    //   const [startDate, endDate] = time;

    //   const startTime = Util.dateTimeUtilnohms(startDate);
    //   const endTime = Util.dateTimeUtilnohms(endDate);

    //   outerParams.created_start_time = startTime;

    //   outerParams.created_end_time = endTime;
    // }

    // if (
    //   mode == "exportExcel" &&
    //   !(outerParams.created_start_time && outerParams.created_end_time)
    // ) {
    //   this.$message.error("请选择时段导出数据");
    //   return null;
    // }

    if (mode === "all") {
      // outerParams.page = pageNo;
      //
      // outerParams.limit = pageSize;

      outerParams.__isUnique = !firstLoading;
    }

    console.log('22222222222222222222',outerParams);

    return outerParams;
  }

  // 后台返回的字段 转化为前端定义的字段
  private handleTableData(data: any): any {
    const {} = data;

    const newData = {
      ...data,
    };

    return newData;
  }



  private restForm(): void {
    this.form = this.utilInstance.clearObject(this.form);

    this.getTable();
  }

  private search(): void {
    this.tablePage.pageNo = 1;
    this.tableData = [];
    this.tablePage.totalCount = 0;

    this.getTable();
  }

  private tableData: any[] = [];

  private tablePage: any = {
    totalCount: 0,
    pageNo: 1,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100, 200, 500],
  };

  private handlePageChange(val: any) {
    this.tablePage.pageNo = val.currentPage;
    this.tablePage.pageSize = val.pageSize;

    this.getTable();
  }

  private exportTable() {
    // new HealthWarning().exportTable(this.form);
  }
}
